import { render } from "./MenuUserModuleMain.vue?vue&type=template&id=4d6df7c2&scoped=true"
import script from "./MenuUserModuleMain.vue?vue&type=script&lang=js"
export * from "./MenuUserModuleMain.vue?vue&type=script&lang=js"

import "./MenuUserModuleMain.vue?vue&type=style&index=0&id=4d6df7c2&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6df7c2"]])

export default __exports__